/*
 *   File : custom-select.js
 *   Author : https://evoqins.com
 *   Description : Custom select component
 *   Integrations : react-select
 *   Version : 1.0.0
*/

import React, { memo } from 'react';
import Select, { components } from 'react-select';

//style
import style from "../../Styles/Component/input.module.scss";

//Custom components
import { Icon } from '../Icon';

const CustomOption = (props) => {
    return (
        <components.Option {...props}>
            <div className='d-flex gap-2 align-items-center'>
                <Icon icon={props.isSelected ? "radio-active" : "radio-inactive"}
                    size="16px" />
                <div className='d-flex gap-1 align-items-center'>
                    {props.data.icon !== null &&
                        <img src={props.data.icon}
                            alt='icon' />
                    }
                    <p className='mb-0'>
                        {props.data.label}
                    </p>
                </div>
            </div>
        </components.Option>
    );
};

const CustomOptionWithoutIcon = (props) => {
    return (
        <components.Option {...props}>
            <div className='d-flex gap-2 align-items-center'>
                <Icon icon={props.isSelected ? "radio-active" : "radio-inactive"}
                    size="16px" />
                <p className='mb-0'>
                    {props.data.label}
                </p>
            </div>
        </components.Option>
    );
};

const CustomSelectBox = (props) => {

    // handle select value 
    const valueChange = (e) => {
        props.selectChange(e);
    };

    return (
        <div className={props.wrapperClass}>
            {props.label &&
                <label className={`${props.labelClass} padding-4px-bottom e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-500 line-height-20px`}>
                    {props.label}
                    {props.require &&
                        <span className='e-text-vermilion'>*</span>
                    }
                </label>
            }
            <div className='position-relative'>
                <Select isSearchable={props.isSearchable}
                    isClearable={props.isClearable}
                    className={`e-select-box ${props.className}`}
                    isDisabled={props.isDisabled}
                    options={props.options}
                    value={props.value ? props.value : ""}
                    isMulti={props.selectType}
                    placeholder={props.placeholder}
                    defaultValue={props.value}
                    menuIsOpen={props.menuIsOpen}
                    components={{
                        Option: props.type === 1 ? CustomOption : CustomOptionWithoutIcon,
                    }}
                    styles={{
                        dropdownIndicator: (base, state) => ({
                            ...base,
                            transition: "all .2s ease",
                            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
                            padding: "0",
                            color: "#141514",
                            width: "16px"
                        }),
                        indicatorSeparator: () => ({
                            display: 'none'
                        }),

                        control: (styles, state) => ({
                            ...styles,
                            borderColor: state.menuIsOpen || props.selected ? '#4530B3' : props.error ? '#D92D20' : '#D5D5D7',
                            boxShadow: state.menuIsOpen ? '#C1B5FF' : 'none',
                            '&:hover': {
                                borderColor: state.menuIsOpen || props.selected ? '' : props.error ? '#D92D20' : '#D5D5D7',
                            },
                            border: props.border,
                            borderRadius: props.borderRadius ? props.borderRadius : "40px",
                            cursor: "pointer",
                            background: props.background ? props.background : "transparent",
                            display: 'flex',
                            alignItems: 'center',
                            padding: props.padding ? props.padding : "4px 4px",
                            fontSize: props.fontSize ? props.fontSize : "14px",
                            fontFamily: "lato",
                            fontWeight: "600",
                            width: props.width ? props.width : "",
                            minHeight: "auto",
                            lineHeigh: "20px",
                            caretColor: "transparent"
                        }),
                        placeholder: (styles) => ({
                            ...styles,
                            color: "#64748B",
                            fontSize: "12px",
                            fontFamily: "lato",
                            fontWeight: "400",
                            lineHeight: "18px"
                        }),

                        menu: (styles) => ({
                            ...styles,
                            fontSize: "14px",
                            fontFamily: "lato",
                            fontWeight: "400",
                            width: props.menuWidth ? props.menuWidth : "max-content",
                            right: "0px",
                            backgroundColor: '#FFFFFF',
                            boxShadow: '2px -2px 27.8px -4px rgba(16, 24, 40, 0.2)',
                            borderRadius: props.menuBorderRadius ? props.menuBorderRadius : '1rem',
                            overflow: "hidden"
                        }),

                        menuList: (base_style) => ({
                            ...base_style,
                            "&::-webkit-scrollbar": {
                                display: "none"
                            },
                        }),

                        option: (styles, { isSelected }) => ({
                            ...styles,
                            backgroundColor: isSelected ? 'transparent' : null,
                            color: isSelected ? '#141514' : '#141514',
                            cursor: "pointer",
                            '&:hover': {
                                backgroundColor: '#EBE7FF',
                            },
                        }),

                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                    menuPortalTarget={props.menuPortalTarget}
                    onMenuOpen={props.onMenuOpen}
                    onMenuClose={props.onMenuClose}
                    onChange={(e) => { valueChange(e) }}
                    {...props}
                />

                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-vermilion e-alt-font-lato e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>

            {props.error &&
                <p className={`position-absolute mb-0 e-text-vermilion e-alt-font-lato e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                    {props.error}
                </p>
            }
        </div>
    )
}

export default memo(CustomSelectBox);
